import { getApolloClient } from '../lib/getApolloClient';
import { GET_CORE_LOOP_CONFIGURATION } from './coreLoopConfiguration.gql';

export const coreLoopConfigurationActions = {
  fetchAndSetCoreLoopConfiguration: async (tenantId: string) => {
    try {
      const { data } = await getApolloClient().query({
        query: GET_CORE_LOOP_CONFIGURATION,
        variables: { tenantId },
      });
      if (data?.getCoreLoopConfiguration) {
        return data?.getCoreLoopConfiguration;
      }
      return null;
    } catch (error) {
      console.error('Error fetching core loop configuration:', error);
      return null;
    }
  },
};
